import NotFound from '../pages/NotFound'
const notFound: IRouter[] = [
  {
    path: '*',
    element: <NotFound />,
  },
]
export default notFound